import { type FC } from "react";

import { Button, ButtonType } from "@ds/components/forms/buttons";
import { IconType } from "@ds/components/icons";
import { ActionsBar } from "@ds/components/actions-bar";

const MODE = {
  EDITING: "EDITING",
  REORDERING: "REORDERING",
  DEFAULT: "DEFAULT",
} as const;

type Mode = (typeof MODE)[keyof typeof MODE];

export const ExperienceDetailsPlayersCardActionsMenu: FC<{
  isDirty: boolean;
  isAggregated: boolean;
  mode: Mode;
  onEdit: () => void;
  onReset: () => void;
  onSubmit: () => void;
  onSaveReorder: () => void;
  onCancelReorder: () => void;
}> = ({ isDirty, isAggregated, mode, onEdit, onReset, onSubmit, onSaveReorder, onCancelReorder }) => {
  if (isAggregated) {
    return null;
  }

  if (mode === MODE.EDITING) {
    return (
      <ActionsBar>
        {/* Always-visible Cancel button */}
        <Button
          label="Cancel"
          ariaLabel="cancel editing players"
          buttonType={ButtonType.Round}
          icon={IconType.Close}
          onClick={onReset}
        />
        {/* Save button - only visible when form is dirty */}
        {isDirty && (
          <Button
            label="Save"
            ariaLabel="save players changes"
            buttonType={ButtonType.Round}
            icon={IconType.Save}
            onClick={onSubmit}
          />
        )}
      </ActionsBar>
    );
  }

  if (mode === MODE.REORDERING) {
    return (
      <ActionsBar>
        <Button
          label="Cancel"
          ariaLabel="cancel reordering players"
          buttonType={ButtonType.Round}
          icon={IconType.Close}
          onClick={onCancelReorder}
        ></Button>
        <Button
          label="Save Order"
          ariaLabel="save reordered players"
          buttonType={ButtonType.Round}
          icon={IconType.Save}
          onClick={onSaveReorder}
        ></Button>
      </ActionsBar>
    );
  }

  return (
    <ActionsBar>
      <Button ariaLabel="Edit players" buttonType={ButtonType.Round} icon={IconType.Update} onClick={onEdit} />
    </ActionsBar>
  );
};
